import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addItemToBasket } from "../../actions/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingBasket } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { ButtonToolbar, Button } from "react-bootstrap";
import ClientModal from "./modals/ClientModal";
import ClientResponseModal from "./modals/ClientResponseModal";
import NotificationModal from "./modals/NotificationModal";
import AlertModal from "./modals/AlertModal";
import { setProductName } from "../../actions/index";
import "../../assets/styles/buttons.scss";

const ButtonComponent = (props) => {
    const subsriptionState = useSelector(
        (state) => state.subscriptionReducer.subscribeState,
    );
    const budget = useSelector(
        (state) => state.clientDataReducer.remainingBudget,
    );
    const total = useSelector((state) => state.cartReducer.total);
    const remainingBudget = budget ? budget - total : 0;

    const orderType = useSelector(
        (state) => state.clientDataReducer.marketingOrderType,
    );
    const products = useSelector((state) => state.cartReducer.items);
    const [productQuantity, setProductQuantity] = useState({ id: 1 });
    const [disabled, setDisabled] = useState(false);
    const [quantityLocation] = useState(false);
    const [name, setName] = useState("");
    const [productid, setProductid] = useState();
    const [modalShow, setModalShow] = React.useState(false);
    const [modalShowResponse, setModalShowResponse] = React.useState(false);
    const [modalShowPaidOrders, setModalShowPaidOrders] = React.useState(false);
    const [modalShowAlert, setModalShowAlert] = React.useState(false);
    const buttonsNotBlocked = useSelector(
        (state) => state.pageReducer.pageLock,
    );

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const input = useRef();

    const token = localStorage.getItem("token");

    const clientResponseModal = document.querySelector(
        "#clientResponseButtonModal",
    );

    useEffect(() => {
        setModalShow(false);
        if (subsriptionState === true) {
            clientResponseModal.click();
        }
        if (subsriptionState === false) {
            clientResponseModal.click();
        }
        //eslint-disable-next-line
    }, [subsriptionState]);

    useEffect(() => {
        if (props.changeProduct) {
            if (input.current !== null) {
                input.current.value = 1;
                setProductQuantity({ id: 1 });
            }
        }
        if (disabled) {
            if (input.current !== null) {
                setProductQuantity({ id: input.current.value });
            }
        }
        products.map((item) => {
            if (
                input.current &&
                item.product &&
                input.current.id === item.product.id
            ) {
                if (input.current.value > item.availability) {
                    setDisabled(true);
                } else {
                    setDisabled(false);
                }
            }
            return disabled;
        });
    }, [props.changeProduct, disabled, products, dispatch]);

    const changeQuantityHandler = (event) => {
        setProductQuantity({
            [event.target.id]: event.target.value,
        });
        products.map((item) => {
            if (event.target.id === item.product.id) {
                if (event.target.value > item.availability) {
                    setDisabled(true);
                } else {
                    setDisabled(false);
                }
            }
            return disabled;
        });
    };

    const wrongQuantityAlert = (orderedQuantity) => {
        alert(`${t(`Basket.Alert`)}${orderedQuantity}`);
    };

    const dispatchHandler = (event) => {
        const properQuantity =
            parseInt(+input.current.value) === 0
                ? 1
                : parseInt(+input.current.value);
        const finalQuantity = +input.current.value === 0 ? 0 : properQuantity;
        input.current.value = finalQuantity;
        const finalProductQuantityObject = { ...productQuantity };
        finalProductQuantityObject[props.itemId] = finalQuantity.toString();

        if (buttonsNotBlocked === false) return false;
        if (disabled && props.availabaleItemQuantity > 0) {
            setModalShowAlert(true);
            return false;
        }
        if (input.current.value < 0) {
            setModalShowAlert(true);
            return false;
        }
        if (props.availabaleItemQuantity === 0) {
            event.preventDefault();
            return false;
        }
        if (
            input.current.value * props.price > remainingBudget &&
            orderType === "S5"
        ) {
            setModalShowPaidOrders(true);
            event.preventDefault();
        } else {
            dispatch(
                addItemToBasket(
                    props.itemId,
                    finalProductQuantityObject,
                    props.itemUnit,
                    token,
                    quantityLocation,
                    wrongQuantityAlert,
                ),
            );
            dispatch(setProductName(props.itemTitle, input.current.value));
            setProductQuantity({ id: input.current.value });
        }
    };

    const handleShowModal = () => {
        if (buttonsNotBlocked === true) {
            setModalShow(true);
            setName(props.itemTitle);
            dispatch(setProductName(props.itemTitle));
            setProductid(props.itemId);
        }
    };

    const handleShowModalResponse = () => {
        if (buttonsNotBlocked === true) {
            setModalShowResponse(true);
        }
    };

    return (
        <>
            {props.availabaleItemQuantity === 0 ? (
                <>
                    <div className="product-input col-12 p-0 d-flex align-items-center justify-content-center">
                        <ButtonToolbar className="w-100">
                            <Button
                                className="availability-check unselectable"
                                onClick={handleShowModal}
                            >
                                {t("Button.NotifyWhenAvailable")}
                            </Button>
                            <ClientModal
                                show={modalShow}
                                onHide={() => setModalShow(false)}
                                name={name}
                                productid={productid}
                            />
                        </ButtonToolbar>
                    </div>
                    <div>
                        <ButtonToolbar className="invisible">
                            <Button
                                className="availability-check unselectable"
                                id="clientResponseButtonModal"
                                onClick={handleShowModalResponse}
                            ></Button>
                            <ClientResponseModal
                                show={modalShowResponse}
                                onHide={() => setModalShowResponse(false)}
                                name={name}
                            />
                        </ButtonToolbar>
                    </div>
                </>
            ) : (
                <div className="product-input col-7 p-0 d-flex align-items-center justify-content-center">
                    <input
                        type="number"
                        ref={input}
                        className="form-control product-input basket-quantity-input"
                        id={props.itemId}
                        defaultValue={productQuantity.id}
                        onChange={changeQuantityHandler}
                        min="0"
                    />
                    <span className="font-weight-bold ml-1">
                        {props.itemUnit}
                    </span>
                </div>
            )}
            {props.availabaleItemQuantity !== 0 && (
                <div className="product-basket-icon col-5 p-0">
                    <FontAwesomeIcon
                        icon={faShoppingBasket}
                        size="2x"
                        color={
                            props.availabaleItemQuantity === 0
                                ? "#e2e2e2"
                                : "#a0a3a6"
                        }
                        // data-toggle="modal"
                        data-target="#proposalModal"
                        onClick={dispatchHandler}
                        cursor="pointer"
                        className="icon-anim"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={t("Button.AddToCart")}
                    />
                </div>
            )}
            <ButtonToolbar className="invisible">
                <Button
                    className="availability-check unselectable paid-orders-modal"
                    id="paid-orders-modal"
                ></Button>
                <NotificationModal
                    show={modalShowPaidOrders}
                    onHide={() => setModalShowPaidOrders(false)}
                    text={t("PaidOrder.ProductsWarning")}
                    header={t("PaidOrder.Header")}
                    itemTitle={props.itemTitle}
                    price={props.price}
                    unit={props.itemUnit}
                    budget={remainingBudget}
                    currency={props.currency}
                    inputValue={input.current && input.current.value}
                />
                <Button
                    className="availability-check unselectable alert-modal"
                    id="alert-modal"
                ></Button>
                <AlertModal
                    show={modalShowAlert}
                    onHide={() => setModalShowAlert(false)}
                    header={t("Button.InvalidValue")}
                    text={t("Button.TheValueEntered")}
                />
            </ButtonToolbar>
        </>
    );
};

export default ButtonComponent;
